import React from "react";

const logout = () => {
  return {
    type: "logout",
  };
};

export default logout;
